import React from "react";
import { Link } from "react-router-dom";
import "./ModalTacticaJuego.css";

interface MenuOption {
  to: string;
  icon: string;
  title: string;
  subtitle?: string;
  gradient: string;
  category?: string;
}

const ModalTacticaJuego = ({
  closeFn,
  branchId,
}: {
  closeFn: () => void;
  branchId: number;
}) => {
  const menuOptions: MenuOption[] = [
    {
      to: `horario/${branchId}`,
      icon: "../assets/img/icons/schedule.png",
      title: "Horario",
      gradient: "#800080",
      category: "Horarios",
    },
    {
      to: `horario-fecha/${branchId}`,
      icon: "../assets/img/icons/schedule.png",
      title: "Horario por fecha",
      gradient: "#FF69B4",
      category: "Horarios",
    },
    {
      to: `chequeo/${branchId}`,
      icon: "../assets/img/icons/summarySchedule.png",
      title: "Reporte reloj",
      gradient: "#1E90FF",
      category: "Reportes",
    },
    {
      to: `reporte-codigo/${branchId}`,
      icon: "../assets/img/icons/checkAssistence.png",
      title: "Códigos",
      gradient: "#50B7C0",
      category: "Reportes",
    },
    // {
    //   to: `resumen-horario/${branchId}`,
    //   icon: "../assets/img/icons/gridIcon.webp",
    //   title: "Resumen",
    //   gradient: "#F7B917",
    //   category: "Resúmenes",
    // },
    {
      to: `incidencias/${branchId}`,
      icon: "../assets/img/icons/incidencias.png",
      title: "Incidencias",
      gradient: "#FA0A0A",
      category: "Alertas",
    },
    {
      to: `resumen-horario-asistencia/${branchId}`,
      icon: "../assets/img/icons/coberturaTiempoReal.png",
      title: "Cobertura",
      gradient: "#008080",
      category: "Resúmenes",
    },
    {
      to: `resumen-all-week/${branchId}`,
      icon: "../assets/img/icons/noDescanso.png",
      title: "Sin descanso",
      gradient: "#FFA500",
      category: "Alertas",
    },
    {
      to: `resumen-doble-funcion/${branchId}`,
      icon: "../assets/img/icons/dobleFunction.png",
      title: "Programados doble función",
      gradient: "#A52A2A",
      category: "Resúmenes",
    },
    {
      to: `resumen-doble-turno/${branchId}`,
      icon: "../assets/img/icons/dobleShift.png",
      title: "Programados doble turno",
      gradient: "#DC2C27",
      category: "Resúmenes",
    },
    {
      to: `resumen-single-work/${branchId}`,
      icon: "../assets/img/icons/singleDayWork.png",
      title: "Programados -2 días",
      gradient: "#4B0082",
      category: "Resúmenes",
    },
    // {
    //   to: `resumen-duplicate-device/${branchId}`,
    //   icon: "../assets/img/icons/checkAssistence.png",
    //   title: "Chequeos dispositivos",
    //   gradient: "#FF00FF",
    //   category: "Reportes",
    // },
    {
      to: `cubrir-puestos-urgente/${branchId}`,
      icon: "../assets/img/icons/cubrirPuestosUrgente.png",
      title: "Cubrir puestos",
      subtitle: "Urgente",
      gradient: "#FA0A0A",
      category: "Alertas",
    },
    {
      to: `organigrama-workers/${branchId}`,
      icon: "../assets/img/icons/organigramaImage.png",
      title: "Organigrama sucursal",
      gradient: "#1E90FF",
      category: "Organización",
    },
    {
      to: `dias-sin-asistencia/${branchId}`,
      icon: "../assets/img/icons/incidencias.png",
      title: "Días sin asistencia",
      gradient: "#DC2C27",
      category: "Alertas",
    },
    {
      to: `dias-descanso/${branchId}`,
      icon: "../assets/img/icons/noDescanso.png",
      title: "Días de descanso",
      gradient: "#22C55E",
      category: "Reportes",
    },
    // {
    //   to: `Aclaraciones-horario/${branchId}`,
    //   icon: "../assets/img/icons/aclaracion-reloj.png",
    //   title: "Aclaraciones horario",
    //   gradient: "#FFCC00",
    //   category: "Alertas",
    // },
    {
      to: `config-horario-semanal/${branchId}`,
      icon: "../assets/img/icons/schedule.png",
      title: "Configurar horario semanal",
      gradient: "#8B008B",
      category: "Horarios",
    },
  ];

  return (
    <div className="modal-tactica-container">
      <div className="container">
        <div className="row g-4">
          {menuOptions.map((option, index) => (
            <div
              key={index}
              className="col-12 col-sm-6 col-md-4 col-lg-3"
              style={{ animationDelay: `${index * 0.05}s` }}
            >
              <Link
                to={option.to}
                className="menu-card"
                style={{
                  background: option.gradient,
                }}
              >
                <div className="menu-card-content">
                  <div className="menu-card-icon-wrapper">
                    <img
                      src={option.icon}
                      alt={option.title}
                      className="menu-card-icon"
                    />
                  </div>
                  <h3 className="menu-card-title">{option.title}</h3>
                  {option.subtitle && (
                    <span className="menu-card-badge">{option.subtitle}</span>
                  )}
                </div>
                <div className="menu-card-overlay"></div>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ModalTacticaJuego;
